// utils/importImages.js
function importAll(r) {
  return r.keys().map(r);
}

// Importar imágenes de cada proyecto
const ciudadImages = importAll(require.context('../ciudad deportiva', false, /\.(png|jpe?g|svg)$/));
const ariguanaboImages = importAll(require.context('../ariguanabo', false, /\.(png|jpe?g|svg)$/));
const albuquerqueImages = importAll(require.context('../albuquerque', false, /\.(png|jpe?g|svg)$/));
const hiniestaImages = importAll(require.context('../la hiniesta', false, /\.(png|jpe?g|svg)$/));
const sacosDurcalImages = importAll(require.context('../sacos durcal', false, /\.(png|jpe?g|svg)$/));
const quentarImages = importAll(require.context('../quentar', false, /\.(png|jpe?g|svg)$/));

export const projectsImages = {
  const1: ciudadImages,     // Ciudad Deportiva 
  panel1: ariguanaboImages, // Ariguanabo
  panel2: albuquerqueImages, // Albuquerque
  panel3: hiniestaImages,   // La Hiniesta
  panel4: sacosDurcalImages, // Sacos Durcal
  house1: quentarImages   //8 casas Quentar
};

export const imageMap = {
  'const1': 'Ciudad Deportiva',
  'panel1': 'Artemisa',
  'panel2': 'Albuquerque',
  'panel3': 'La Hiniesta',
  'panel4': 'Sacos Dúrcal',
  'house1': 'Quéntar'
};